import { useAtom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const ClientCodeStorageKey = 'moxieClientCode'
export const clientCodeAtom = atomWithStorage<string | undefined>(ClientCodeStorageKey, undefined, undefined, {
    getOnInit: true,
})

export const useClientCode = () => {
    const [clientCode] = useAtom(clientCodeAtom)

    return clientCode
}

export const useSetClientCode = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [_, setClientCode] = useAtom(clientCodeAtom)

    return setClientCode
}
